const TIMESTAMP_LENGTH = 14;

function parseBuildVersion(version: string) {
  const trimmed = version.trim();
  if (!trimmed) return null;

  const dashIndex = trimmed.indexOf("-");
  if (dashIndex <= 0) return null;

  const timestamp = trimmed.slice(0, dashIndex);
  const hash = trimmed.slice(dashIndex + 1);

  if (
    timestamp.length !== TIMESTAMP_LENGTH ||
    !/^\d+$/.test(timestamp) ||
    !hash
  ) {
    return null;
  }

  return { timestamp, hash };
}

export function isNewerVersion(serverVersion: string, clientVersion: string) {
  const server = parseBuildVersion(serverVersion);
  const client = parseBuildVersion(clientVersion);

  if (!server || !client) return false;
  if (server.timestamp === client.timestamp && server.hash === client.hash) {
    return false;
  }
  if (server.timestamp > client.timestamp) return true;
  if (server.timestamp < client.timestamp) return false;
  return server.hash !== client.hash;
}
